module.exports = __webpack_public_path__ + "img/d9228a7.jpg";